module.exports = __webpack_public_path__ + "img/employManage.1a10e44a.png";